var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", [
                _c("h2", { staticClass: "mb-0" }, [
                  _vm._v("Metas de Retenção")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    '\n          Faixas de meta (% de distribuidores retidos na região da analista) e o prêmio de cada uma, por mês.\n          Aparecem aqui os usuários com "Região da retenção" no cadastro.\n        '
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "mt-2 mt-md-0",
                  attrs: { cols: "12", md: "auto" }
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: {
                        variant: "outline-secondary",
                        size: "sm",
                        href: "/adm/retencao"
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-arrow-left" }),
                      _vm._v(" Retenção\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "mb-0 mr-2" }, [_vm._v("Mês")]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "d-inline-block",
                    staticStyle: { width: "170px" },
                    attrs: {
                      type: "month",
                      size: "sm",
                      disabled: _vm.loading || _vm.salvando
                    },
                    on: {
                      change: function($event) {
                        return _vm.carregar()
                      }
                    },
                    model: {
                      value: _vm.competencia,
                      callback: function($$v) {
                        _vm.competencia = $$v
                      },
                      expression: "competencia"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "text-center my-5" },
                [_c("b-spinner")],
                1
              )
            : !_vm.analistas.length
            ? _c("div", { staticClass: "text-center text-muted my-5" }, [
                _vm._v(
                  "\n      Nenhum usuário com região da retenção. Defina a região no cadastro de usuários.\n    "
                )
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mt-3 mb-2"
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "outline-primary",
                          size: "sm",
                          disabled: _vm.salvando || !_vm.temAnterior
                        },
                        on: {
                          click: function($event) {
                            return _vm.copiarAnterior()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "far fa-copy" }),
                        _vm._v(
                          " Copiar faixas de " +
                            _vm._s(_vm.nomeMes(_vm.anterior)) +
                            " (para quem está sem)\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.alterado
                      ? _c("span", { staticClass: "text-warning small" }, [
                          _c("i", { staticClass: "fas fa-exclamation-circle" }),
                          _vm._v(" Alterações não salvas\n        ")
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-sm table-bordered metas" },
                  [
                    _c("thead", { staticClass: "thead-dark" }, [
                      _c("tr", [
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v("Região")
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Analista")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "Faixas de " + _vm._s(_vm.nomeMes(_vm.anterior))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "Faixas de " + _vm._s(_vm.nomeMes(_vm.competencia))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v("Última alteração")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.analistas, function(a) {
                        return _c(
                          "tr",
                          { key: a.user_id, class: { "text-muted": !a.ativo } },
                          [
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(a.regiao))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(a.nome) +
                                    "\n              "
                                ),
                                !a.ativo
                                  ? _c(
                                      "b-badge",
                                      {
                                        staticClass: "ml-1",
                                        attrs: { variant: "secondary" }
                                      },
                                      [_vm._v("inativo")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "small text-muted" }, [
                                  _vm._v(_vm._s(a.email))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "small" },
                              [
                                _vm._l(a.faixas_anteriores, function(f) {
                                  return _c("div", { key: f.faixa }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.formataPct(f.meta)) +
                                        " "
                                    ),
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v("→")
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.formataReal(f.premio)) +
                                        "\n              "
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                !a.faixas_anteriores.length
                                  ? _c("span", { staticClass: "text-muted" }, [
                                      _vm._v("-")
                                    ])
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._l(a.faixas, function(f, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass:
                                        "d-flex align-items-center mb-1"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small text-muted mr-2 faixa-n"
                                        },
                                        [_vm._v(_vm._s(i + 1) + "ª")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group",
                                        {
                                          staticClass: "mr-2 meta-input",
                                          attrs: { size: "sm", append: "%" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              max: "100",
                                              step: "0.1",
                                              disabled: _vm.salvando,
                                              placeholder: "meta"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.alterado = true
                                              }
                                            },
                                            model: {
                                              value: f.meta,
                                              callback: function($$v) {
                                                _vm.$set(f, "meta", $$v)
                                              },
                                              expression: "f.meta"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group",
                                        {
                                          staticClass: "mr-2 premio-input",
                                          attrs: { size: "sm", prepend: "R$" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              step: "0.01",
                                              disabled: _vm.salvando,
                                              placeholder: "prêmio"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.alterado = true
                                              }
                                            },
                                            model: {
                                              value: f.premio,
                                              callback: function($$v) {
                                                _vm.$set(f, "premio", $$v)
                                              },
                                              expression: "f.premio"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "text-danger p-0",
                                          attrs: {
                                            size: "sm",
                                            variant: "link",
                                            title: "Remover faixa",
                                            disabled: _vm.salvando
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removerFaixa(a, i)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-times"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "p-0",
                                    attrs: {
                                      size: "sm",
                                      variant: "link",
                                      disabled: _vm.salvando
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.adicionarFaixa(a)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-plus" }),
                                    _vm._v(" faixa\n              ")
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center small" }, [
                              _vm._v(_vm._s(a.alterado_em || ""))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: _vm.salvando || !_vm.alterado
                        },
                        on: {
                          click: function($event) {
                            return _vm.salvar()
                          }
                        }
                      },
                      [
                        _vm.salvando
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _c("i", { staticClass: "fas fa-save" }),
                        _vm._v(
                          "\n          Salvar metas de " +
                            _vm._s(_vm.nomeMes(_vm.competencia)) +
                            "\n        "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbae3b1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbae3b1c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_retencao/Metas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-dbae3b1c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_retencao/Metas.vue
// module chunks = 2